module.exports = __webpack_public_path__ + "static/media/vinglabs_design_color_transparent.f4d64ddf.png";